<template>
  <div>
    <v-progress-linear v-if="feedback.loading" :indeterminate="true" height="2"></v-progress-linear>
    <v-card-title>
      <span class="headline">#{{ feedback.id }} - {{ feedback.admin.nickname }}</span>
      <v-spacer></v-spacer>
      <stars :note="feedback.note"></stars>
    </v-card-title>
  </div>
</template>

<script>
  import Stars from '@/components/Stars.vue'
  export default {
    components: {
      Stars
    },
    props: {
      feedback: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .progress-linear {
    height: 1px;
    margin: 0;
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/FeedbackHeader.vue